import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Input } from '@progress/kendo-react-inputs';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';

function EmailRenderer({ field, value, onChange, readOnly }: FieldRendererProps) {
  return (
    <Input
      type="email"
      value={typeof value === 'string' ? value : ''}
      onChange={(e) => onChange(e.value ?? '')}
      disabled={readOnly}
      placeholder={field.label}
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'EMAIL',
  label: 'Email',
  category: 'formatted',
  icon: <FontAwesomeIcon icon={faEnvelope} fixedWidth />,
  defaultProps: {
    label: 'Email Address',
    isRequired: false,
    validation: { pattern: '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$' },
  },
  Renderer: EmailRenderer,
};
